import React from 'react';
import { useFeatureFlagContext } from '@modules/feature-flags/client/providers/FeatureFlagProvider';

export type SettingsSection = {
  id: string;
  title: string;
  component: React.ComponentType;
  order: number;
  visible?: () => boolean;
  featureFlag?: string;
};

class AdminSettingsRegistryClass {
  private _sections: SettingsSection[] = [];

  addSection(section: SettingsSection): void {
    this._sections.push(section);
  }

  removeSection(id: string): void {
    this._sections = this._sections.filter((s) => s.id !== id);
  }

  getSections(): SettingsSection[] {
    return [...this._sections].sort((a, b) => a.order - b.order);
  }
}

export const AdminSettingsRegistry = new AdminSettingsRegistryClass();

export const useAdminSettingsSections = (): SettingsSection[] => {
  const { isEnabled } = useFeatureFlagContext();
  return AdminSettingsRegistry.getSections().filter((section) => {
    if (section.featureFlag && !isEnabled(section.featureFlag)) {
      return false;
    }
    if (section.visible && !section.visible()) {
      return false;
    }
    return true;
  });
};
